/**
 * Calculate the height to remove to the element to scroll
 * It is need it to handle the menu height in mobile and desktop
 * @returns {number} the proper height of the header and help content if exists
 */
function calculateHeaderHeight() {
  const headerGroup = document.querySelector('.header-group');
  return headerGroup?.offsetHeight || 0;
}

/**
 * Scroll the content to a calculate position
 * @param {HTMLElement} contentToScroll html element scroll container
 * @param {jQuery} $hook optional jQuery element to point the scroll
 * @param {number} timing optional timing animation
 */
function scrollToPosition(contentToScroll, $hook = null, timing = 1000) {
  const hookTopPosition = () =>
    $hook instanceof jQuery
      ? $hook.offset().top
      : $hook.getBoundingClientRect().top + window.scrollY;
  const positionToScroll = $hook
    ? hookTopPosition() - calculateHeaderHeight()
    : 0;

  $(contentToScroll).animate(
    {
      scrollTop: positionToScroll,
    },
    timing
  );
}

/**
 * Sets the button that scrolls to top of the page or the content, to visible value
 * @param {jQuery} $element the button that wants to change the attribute
 * @param {boolean} visible set the value of the attribute
 */
function buttonScrollToTopVisible($element, visible) {
  $element.attr('data-is-visible', visible);
}

/**
 * Handle the click event when Button scroll to top is clicked
 * This case is going to scroll to top, so it called the scrollToPosition with no arguments
 * @param {MouseEvent} event
 * @param {HTMLElement} elementToScroll scroll container element
 * @param {jQuery} $hook optional jQuery element to point the scroll
 */
function onClickButtonScrollToTop(event, elementToScroll, $hook = null) {
  event.preventDefault();
  scrollToPosition(elementToScroll, $hook);
}

module.exports = {
  scrollToPosition,
  buttonScrollToTopVisible,
  onClickButtonScrollToTop,
};
